module.exports = __webpack_public_path__ + "img/Rectangle 673.c2b1eda0.png";